export function plural(number, array) {
    const keys = [2, 0, 1, 1, 1, 2];
    return array[number % 100 > 4 && number % 100 < 20 ? 2 : keys[Math.min(number % 10, 5)]];
}
